<template>
  <v-container fluid>
    <v-card>
      <v-container class="ma-0 pa-0" fluid>
        <v-layout row style="padding:1px;">
          <v-layout> </v-layout>
          <v-tooltip top>
            <v-btn
              fab
              dark
              small
              color="amber darken-2"
              slot="activator"
              @click="downloadExcel()"
            >
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                />
              </svg>
            </v-btn>
            <span>Download Excel File</span>
          </v-tooltip>
          <refresh-button @refresh="getData()"></refresh-button>
        </v-layout>
        <v-container grid-list-xs fluid class="mb-0 pb-0" style="padding: 5px;">
          <v-container
            grid-list-lg
            fluid
            style="padding: 0px;"
            class="pt-3"
          ></v-container>
        </v-container>
        <v-divider></v-divider>

        <!-- <bottom-scroll @on-bottom="loadMore" :offset="queryParams.offset"> -->
        <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          disable-initial-sort
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  header.value === queryParams.order ? 'active' : '',
                  'text-xs-' + header.align,
                ]"
              >
                <span>{{ header.text.toUpperCase() }}</span>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center" data-v-0f785e6e>
              {{ props.index + 1 }}
            </td>
            <td class="text-xs-left text-uppercase">
              {{ props.item.month ? props.item.month : "--" }}
            </td>
            <td class="text-xs-left no-wrap">
              {{ props.item.min ? props.item.min : "--" }}
            </td>
            <td class="text-xs-left no-wrap">
              {{ props.item.permit_to_use ? props.item.permit_to_use : "--" }}
            </td>
            <td class="text-xs-left text-uppercase no-wrap">
              {{ props.item.accreditation ? props.item.accreditation : "--" }}
            </td>
            <td class="text-xs-left text-uppercase">
              {{
                props.item.total_sales
                  ? $amountInPeso(props.item.total_sales)
                  : $amountInPeso(0)
              }}
            </td>
            <td class="text-xs-left text-uppercase">
              {{ props.item.last_or_no ? props.item.last_or_no : "--" }}
            </td>
          </template>
        </v-data-table>
        <!-- </bottom-scroll> -->
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import XLSX from "xlsx";
const now = new Date();

export default {
  data() {
    return {
      //filter
      openFilter: false,
      filterCompanies: [],
      filterCompany: null,
      filterSubCompanies: [],
      filterSubCompany: null,

      title: "E-sales",
      timeOut: null,
      theTableStyle: false,
      tableItems: [
        {
          text: "Default Table",
          value: false,
        },
        {
          text: "Grid Style Table",
          value: true,
        },
      ],
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Month",
          align: "left",
        },
        {
          text: "Machine Identification Number",
          sortable: false,
          align: "left",
          sortable: false,
        },
        {
          text: "Permit To Use",
          align: "left",
          sortable: false,
        },
        {
          text: "Accreditation No.",
          align: "left",
          sortable: false,
        },
        {
          text: "Sales",
          align: "left",
          sortable: false,
        },
        {
          text: "OR No.",
          align: "left",
          sortable: false,
        },
      ],
      items: [],
      totalItems: {},
      queryParams: {
        company_id: null,
        sub_company_id: null,
      },
      play_status: false,
      menu: false,
      menu1: false,
      dateFrom: this.$dateFormat(now, "YYYY-MM"),
      dateTo: this.$dateFormat(now, "YYYY-MM"),
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      },
    },
  },
  methods: {
    async getData() {
      this.items = [];
      // Start Loading
      this.$store.dispatch("startLoading");

      this.queryParams.date_from = this.dateFrom;
      this.queryParams.date_to = this.dateTo;

      try {
        // Query Data
        let response = (await Services.getEsales(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    //  async playData() {
    //   this.items = [];
    //   this.resetTable();
    //   this.play_status = true;
    //   this.getData();
    // },
    //   resetTable() {
    //     this.items = [];
    //   this.queryParams.limit = 300;
    //   this.queryParams.offset = 0;

    //   this.play_status = false;
    // },
    //  async loadMore() {
    //   if (!this.play_status) return;

    //   this.queryParams.offset += this.queryParams.limit;

    //   if (this.queryParams.offset >= this.totalItems) return;

    //   await this.getData();
    // },
    downloadExcel() {
      const wscols = [];
      const dataToDownload = [];
      const header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      header.shift();

      dataToDownload.push(header);

      for (let i = 0; i < this.headers.length; i++) {
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 35 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
        wscols.push({ wch: 20 });
      }

      for (let e = 0; e < this.items.length; e++) {
        const theItem = [];

        theItem.push(this.items[e].month ? this.items[e].month : "--");
        theItem.push(this.items[e].min ? this.items[e].min : "--");
        theItem.push(
          this.items[e].permit_to_use ? this.items[e].permit_to_use : "--"
        );
        theItem.push(
          this.items[e].accreditation ? this.items[e].accreditation : "--"
        );
        theItem.push(
          this.items[e].total_sales ? this.items[e].total_sales : "0"
        );
        theItem.push(
          this.items[e].last_or_no ? this.items[e].last_or_no : "--"
        );
        dataToDownload.push(theItem);
      }

      // don't delete any codes after this comment got it?!

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      var wsname = "SheetJS";

      // var fmt = "#,##0";
      var fmt = "#,##0.00";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports",
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"],
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf",
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null,
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    },
  },
};
</script>

<style scoped>
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
